import React, { useState, useEffect } from 'react';
import KnowledgeGraph from '../components/KnowledgeGraph';
import type { GraphData } from '@packages/shared';
import { convertOPMToKnowledgeGraph } from '../utils/opmToKnowledgeGraph';

const KnowledgeGraphPage: React.FC = () => {
  const [graphData, setGraphData] = useState<GraphData | undefined>(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTestData = async () => {
      try {
        // 动态导入OPM测试数据文件
        const opmData = await import(
          './test-data/opm-diagram-2025-09-18.json'
        );

        // 转换OPM数据为知识图谱数据
        const convertedData = convertOPMToKnowledgeGraph(opmData.default);
        setGraphData(convertedData);
      } catch (error) {
        console.error('Failed to load test data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadTestData();
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex flex-col items-center justify-center">
        <div className="text-lg">加载图谱数据中...</div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col bg-gray-50 p-6">
      {/* 知识图谱容器 */}
      {/* <div className="flex-1 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
        <KnowledgeGraph externalData={graphData} />
      </div> */}

      {/* 可以用固定高度的容器 */}
      <div className="w-full h-96 bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
        <KnowledgeGraph externalData={graphData} />
      </div>
    </div>
  );
};

export default KnowledgeGraphPage;
